export const environment = {
  production: true,
  envName: 'jm',
  apiUrl: 'https://ruby-rest.jmprocurementacademy.com/',
  onboardingCookie: "Ruby_JM_OnboardingDismissed",
  onboardingStepsPath: "assets/json/OnBoarding/steps_jm.json"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts